import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";

import {
  CREATE_VIEW_GROUPS_FORM,
  CREATE_VIEW_GROUPS_TABS,
} from "features/planner/planner.constants";

import PlanningGroupsList from "features/planner/components/View/CreateViewGroups/PlanningGroupsList";
import LocationGroupsList from "features/planner/components/View/CreateViewGroups/LocationGroupsList";

const CreateViewGroupsForm = ({
  activeTab,
  locationGroups,
  planningGroups,
}) => (
  <Grid container direction="column" spacing={2}>
    <Grid item>
      {activeTab === CREATE_VIEW_GROUPS_TABS.LOCATION_GROUP && (
        <LocationGroupsList locationGroups={locationGroups} />
      )}
      {activeTab === CREATE_VIEW_GROUPS_TABS.PLANNING_GROUP && (
        <PlanningGroupsList planningGroups={planningGroups} />
      )}
    </Grid>
  </Grid>
);

export default compose(
  connect((state, { formValueSelector }) => ({
    activeTab: formValueSelector(state, CREATE_VIEW_GROUPS_FORM.ACTIVE_TAB),
  })),
  React.memo,
)(CreateViewGroupsForm);
